import { Component } from '@angular/core';
import { AuthService } from '../../Services/auth.service';

@Component({
  selector: 'app-users-nav-page',
  standalone: false,
  templateUrl: './users-nav-page.component.html',
  styleUrl: './users-nav-page.component.css'
})
export class UsersNavPageComponent {
  menuItems = [
    { path: "adduser", label: "addNewUser", icon: "pi pi-plus" },
    { path: "users", label: "manage", icon: "pi pi-cog" },
  ];

  getIcon(path: string): string {
    const iconMap: { [key: string]: string } = {
      "adduser": "pi pi-plus",  
      "users": "pi pi-cog", 
    };
    return iconMap[path] || "bi bi-circle"; 
  }

  userRole: string;

  constructor(private auth: AuthService) {
    this.userRole = this.auth.getRoles();
  }
}
